export class GLAccountSelectorResultDto {
    glAccountNumber: string;

    title: string;
    baseAccountID: number;
    baseAccountNumber: string;
    subAccountID: number;
    subAccountNumber: string;
    requiresSubCategory: boolean;

    /**
     * Result format: "{GLAccountNumber};-{Title}"
     */
    displayText: string;
}
